import { localStorage } from 'lib/core/services/localStorage'

export const getHeaders = () => {
  const extraHeaders = localStorage.get('extraHeaders')
  const token = localStorage.get('authToken')
  const storeView = localStorage.get('storeView') || process.env.REACT_APP_MAGENTO_STORE_VIEW
  const headers: Record<string, string> = {}
  if (token) {
    headers.authorization = `Bearer ${token}`
  }
  if (storeView) {
    headers.store = storeView
  }
  return {
    ...headers,
    ...extraHeaders
  }
}
